export interface SecurityUpdate {
  title: string;
  description: string;
  date: string;
  category?: string;
}

export const securityUpdates: SecurityUpdate[] = [
  {
    title: "HIPAA Compliance — Voice Transcription",
    description: `<p>We've completed a comprehensive HIPAA compliance audit of our voice transcription system. Key verified controls include:</p>
      <ul>
        <li><strong>TLS Encryption:</strong> All audio data transmitted via TLS 1.2+ (WSS to Azure Speech Services, HTTPS to S3)</li>
        <li><strong>HIPAA-Compliant AI Services:</strong> Azure Speech Services deployed in HIPAA-eligible configuration with server-side key management</li>
        <li><strong>No Local PHI Storage:</strong> Audio and transcripts are never stored in browser localStorage, sessionStorage, or IndexedDB</li>
        <li><strong>Encrypted Storage:</strong> Audio recordings and secure send attachments encrypted at rest with AES-256 in AWS S3</li>
        <li><strong>Access Controls:</strong> Form-level authorization on all transcript endpoints with JWT authentication</li>
      </ul>
      <p>Full compliance documentation is available in our <a href='/trust-center?tab=controls'>Trust Center Controls</a> section.</p>`,
    date: "2026-04-01",
    category: "Compliance",
  },
  {
    title: "Trust Center Update",
    description: `<p>We've significantly enhanced our Trust Center with comprehensive documentation about our security infrastructure and compliance measures. Key updates include detailed information about our security controls, real-time security posture updates, and data protection practices.</p>
      <br />
      <p>We're excited to announce the official launch of 24/7 continuous infrastructure monitoring, featuring automated threat detection, real-time alerts, and enhanced logging capabilities. Learn more about these improvements and our commitment to security at our <a href='/trust-center'>updated Trust Center documentation</a>. As of today your account is automatically enrolled in this new monitoring, and we will forward any alerts to your account's primary email address associated with your office.</p>`,
    date: "2025-03-24",
    category: "Infrastructure",
  },
];
